import BackgroundCheckAuthorization from './BackgroundCheckAuthorization';
export { BackgroundCheckAuthorization };
export default BackgroundCheckAuthorization;
